import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAdmin } from "@/pages/admin/AdminLayout";

export default function CompteAdmin() {
  const { user, setUser } = useAdmin();
  const onUpdated = setUser;
  const [form, setForm] = useState({ current_password: "", new_email: user?.email || "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password && form.new_password !== form.confirm) {
      toast.error("Les deux nouveaux mots de passe ne correspondent pas");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put("/auth/account", {
        current_password: form.current_password,
        new_email: form.new_email.trim(),
        new_password: form.new_password,
      });
      onUpdated?.(data);
      setForm({ current_password: "", new_email: data.email, new_password: "", confirm: "" });
      toast.success("Identifiants mis à jour — utilisez-les à votre prochaine connexion");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  const input = "mt-1.5 w-full rounded-2xl border border-line bg-cream-light px-4 py-3 text-sm outline-none focus:border-teal";

  return (
    <div data-testid="admin-compte-page">
      <h1 className="font-serif text-3xl md:text-4xl text-teal-dark">Mon compte</h1>
      <p className="text-sm text-ink/60 mt-1">Modifiez l'email et le mot de passe de connexion au back office.</p>

      <form onSubmit={submit} className="mt-8 max-w-xl bg-white rounded-3xl border border-line p-6 md:p-8 space-y-5">
        <div className="flex items-start gap-3 rounded-2xl bg-mint/20 p-4 text-sm text-teal-dark">
          <ShieldCheck size={18} className="shrink-0 mt-0.5" />
          <p>Connectée en tant que <strong data-testid="admin-compte-current-email">{user?.email}</strong>. Le mot de passe actuel est requis pour toute modification.</p>
        </div>
        <label className="block text-sm font-medium text-ink">
          Mot de passe actuel *
          <input required type="password" autoComplete="current-password" data-testid="admin-compte-current-password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} className={input} />
        </label>
        <label className="block text-sm font-medium text-ink">
          Email de connexion
          <input type="email" autoComplete="username" data-testid="admin-compte-email" value={form.new_email} onChange={(e) => setForm({ ...form, new_email: e.target.value })} className={input} />
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className="block text-sm font-medium text-ink">
            Nouveau mot de passe
            <input type="password" autoComplete="new-password" data-testid="admin-compte-new-password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} placeholder="Laisser vide pour ne pas changer" className={input} />
          </label>
          <label className="block text-sm font-medium text-ink">
            Confirmer
            <input type="password" autoComplete="new-password" data-testid="admin-compte-confirm" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className={input} />
          </label>
        </div>
        <p className="text-xs text-ink/60">Au moins 10 caractères, avec des lettres et des chiffres.</p>
        <button type="submit" data-testid="admin-compte-save" disabled={saving} className="w-full rounded-full bg-teal py-3.5 font-medium text-cream hover:bg-teal-dark transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {saving && <Loader2 size={16} className="animate-spin" />}
          {saving ? "Enregistrement…" : "Mettre à jour mes identifiants"}
        </button>
      </form>
    </div>
  );
}
